import React, { useRef } from "react";
import { Box } from "@mui/material";

function OrderRequirements(pdf) {

  const pdfRef = useRef(JSON.parse(pdf.pdf));

  return (
    <Box sx={{ height: '100%' }}>
      {pdfRef.current.PdfExists && <iframe src={pdfRef.current.PdfUrl} style={{ width: '100%', height: '100%' }} />}
      {!pdfRef.current.PdfExists && <p style={{ margin: 20 }}>No requirements pdf attached.</p>}
    </Box>
  );
}

export default OrderRequirements;